<template>
  <div>{{ message }}</div>
</template>

<script>

import Auth from "@/apis/Auth";

export default {
  props: {
    token: [String],
  },
  data() {
    return {
      message: this.$t('heading.ssoLoginPage.title'),
      appUrl: "",
    };
  },
  created() {
    Auth.home().then((response) => {
      if (response.data.admin === undefined && response.data.user.password_change_required) {
        this.$router.push({
          path: '/my-account',
          query: {
            change_password_required: true
          }
        });
        return;
      }
      if (response.data.admin === undefined && response.data.user.two_factor_auth_required) {
        this.$router.push({
          path: '/my-account',
          query: {
            two_factor_auth_required: true
          }
        });
        return;
      }

      if (this.$route.query.redirect) {
        this.$router.push({path: this.$route.query.redirect});
        return;
      }

      let query = {};
      if (this.$route.query.branding) {
        query.branding = "true";
      }
      this.$router.push({path: "/instances", query: query});
    });
  },
};
</script>
